import { FormCard } from '@qbe/ads-blocks-forms';
import { Box, Skeleton, Spacer } from '@qbe/ads-core';
import React from 'react';

import { useBreakpoint } from '~/hooks-ds/useBreakpoint';

const AppLoading = () => {
  const { isDesktop, isSmallDesktop } = useBreakpoint();
  // equivalent to ADS --content-padding-content
  const formCardPadding = {
    xs: '32px 24px',
    md: '40px 48px',
  };
  return (
    <Box data-testid="app-loading">
      <Spacer size={isSmallDesktop ? 'xs' : 'md'} />

      <FormCard variant="content" disablePadding>
        <Skeleton
          width="100%"
          height="98px"
          animation="wave"
          sx={{ transform: 'unset' }}
          variant="rectangular"
        />
        <Box padding={formCardPadding} width={isDesktop ? '100%' : '70%'}>
          <Skeleton width="100%" variant="rounded" height="24px" animation="wave" />
        </Box>
      </FormCard>
      <Spacer size="md" />
      <FormCard variant="content">
        <Skeleton
          width={isDesktop ? '100%' : '70%'}
          variant="rounded"
          height="24px"
          animation="wave"
        />
      </FormCard>
    </Box>
  );
};

export default AppLoading;
